import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { useClient } from '../../client-api';
import { type ClientPackageAppendixDocumentDto, deleteAppendixDocument } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useDeleteAppendixDocument = (clientId?: number): UseMutationResult<ClientPackageAppendixDocumentDto, AxiosError, number> => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (documentId) => deleteAppendixDocument({ path: { documentId } }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.clientPackagesForClient(clientId ?? client?.id) });
            showSuccessToast(t('clientPackageAppendixDocumentDeleteSuccess'));
        },
        onError: (error) => showErrorToast({ error, userMessage: t('clientPackageAppendixDocumentDeleteFailure') }),
    });
};
